import { render, staticRenderFns } from "./RepresentativePage.vue?vue&type=template&id=dbc0f816"
import script from "./RepresentativePage.vue?vue&type=script&lang=js"
export * from "./RepresentativePage.vue?vue&type=script&lang=js"
import style0 from "./RepresentativePage.vue?vue&type=style&index=0&id=dbc0f816&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports